import React, {useState}  from 'react';
import {
  Card, 
  CardBody,
  FormGroup, Form, Input , Button
 } from "reactstrap";
import Select from "react-select";
import { useSelector } from 'react-redux'

var Const = require ('Const');
var Utils = require ('Utils') ;

const formatPeriod = ( period ) => {
  var desde = new Date(period.start_date.replace('Z','')) ;
  var hasta = new Date(period.end_date.replace('Z','')) ;
  let dev = "Del "+ desde.getDate() + '/' + Utils.capitalize(Const.MONTHS[desde.getMonth()].toLowerCase()) +
              ' al '+ hasta.getDate() + '/' + Utils.capitalize(Const.MONTHS[hasta.getMonth()].toLowerCase()) ;
  
  return dev ;
  }

 




const StudentSubjectEvalCard = ( { data , token, courseEvals, updateEvals, createEval, delEval, closeMe } ) =>  {
  const [ formData, setFormData] = useState({});

  const isOpen = ( data.col.ev.blocked!=='Y' ) ;
  const evalExists = ( ( data.calif && data.calif.qualif_value_id )|| ( data.calif && data.calif.qualif_value_nbr) ) ;
  const customStyles = {
    singleValue: (provided, state) => ({
      fontWeight: '800'
    })
  }

  const {isSaving } = useSelector(state => ({
     isSaving: state.view.loadingModules.savingEvaluation
  }))

  const confirmCreate = () => {
    if (! (formData.qualif_value_id || formData.qualif_value_nbr) ) alert( "Falta seleccionar la calificación") ;
    else {
        if (Object.keys( formData ).length > 0) {
        let qualifValueToSend = '' ;
        if (formData.qualif_value_id) {
            let qualifValue = courseEvals.qualification_values.filter((q) => q.qualif_value_id === formData.qualif_value_id );
            qualifValueToSend = qualifValue[0] ;
        }
        
        createEval( token,  courseEvals.subject.course_subject_id,  data.student.persona_id, data.evaluationID, 
            qualifValueToSend , formData.qualif_value_nbr, formData.comments )
        setFormData({});
    } 
    setTimeout(function() { closeMe(false); }, 1000)  
    }
}
const confirmDelete = () => {
    delEval( token, data.calif.course_subject_id, data.calif.persona_id, data.calif.evaluation_id)
    setTimeout(function() { closeMe(false); }, 1000)
}
const confirmUpdate = () => {
  if (Object.keys( formData ).length > 0) {
      let qualifValue = {};
      if (formData.qualif_value_id) {
          let selec = courseEvals.qualification_values.filter((q) => q.qualif_value_id === formData.qualif_value_id );
          qualifValue = selec[0];
      }

      updateEvals ( token, data.calif.course_subject_id, data.calif.persona_id, data.calif.evaluation_id, formData, qualifValue )
      setFormData({});
      
    
  } 
setTimeout(function() { closeMe(false); }, 1000)


}



  const saveButtons = () => {
    return (
              <>
                  <hr />
                  <Button color="success" size="sm" disabled={isSaving}
                      
                      onClick={() => { 
                          if (!evalExists) confirmCreate();
                          else confirmUpdate ();
                      } }
                      
                      >
                      {isSaving?
                          <i className="nc-icon nc-refresh-69  fa-spin" />
                          :
                          <>
                              <span className="btn-label">
                                  <i className="fa fa-floppy-o" aria-hidden="true"></i>
                              </span>
                              {evalExists?"Modificar":"Grabar"} 
                          </>
                      }
                  </Button>

                  {evalExists && 
                      <Button color="danger" size="sm" disabled={isSaving}
                          
                          onClick={() => { 
                              confirmDelete();
                          } }
                          
                          >
                          {isSaving?
                              <i className="nc-icon nc-refresh-69  fa-spin" />
                              :
                              <>
                                  <span className="btn-label">
                                      <i className="fa fa-trash" aria-hidden="true"></i>
                                  </span>
                                  Eliminar 
                              </>
                          }
                      </Button>
                  }
              </>
      )

}


  const reduceQualifValuesNumbers = [
    { value: "1", label: "1"},
    { value: "2", label: "2"},
    { value: "3", label: "3"},
    { value: "4", label: "4"},
    { value: "5", label: "5"},
    { value: "6", label: "6"},
    { value: "7", label: "7"},
    { value: "8", label: "8"},
    { value: "9", label: "9"},
    { value: "10", label: "10"},
]

const reduceQualifValuesList = () => {
  if (courseEvals && courseEvals.qualification_values)
      return courseEvals.qualification_values.map( (qualif) => { return { value: qualif.qualif_value_id, label: qualif.name } } ) ;
  else 
      return '';
}

const handleInputChange = (event) => {
  setFormData({ ...formData, [event.target.name]: event.target.value}  )
}
  
        return (

            <div  key="pa" className="content">
              <Card className="card-plain">
                <CardBody>
                     <p className="eval-title">{data.col.ev.name}</p>
                     
                    {(data.col.ev.show_dt !== "N" ) &&
                        <p>{formatPeriod(data.col.ev)}{ !(isOpen) && <> <b>Calificación cerrada</b></>}</p>
                    }
                  <p className="eval-title">Alumno {data.student&&data.student.studentName}</p>

                  <Form>
                         <FormGroup>
                              
                         {data.col.ev.evaluation_type === 'NUM'?
                            <Select
                                        classNamePrefix="react-select"
                                        styles={evalExists?customStyles:''}
                                        name="qualif_value_nbr"
                                        defaultValue={Const.getObjectByValue(reduceQualifValuesNumbers, (data.calif?data.calif.qualif_value_nbr:'5') )}
                                       
                                        onChange={(sel) => 
                                        setFormData({ ...formData, 'qualif_value_nbr': sel.value }  ) }
                                        options={reduceQualifValuesNumbers}
                                        placeholder="Seleccione nota numérica"
                                    />
                            :
                                    <Select
                                        classNamePrefix="react-select"
                                        styles={evalExists?customStyles:''}
                                        name="qualif_value_id"
                                        defaultValue={evalExists && Const.getObjectByValue(reduceQualifValuesList(), data.calif.qualif_value_id)}
                                        onChange={(sel) => 
                                        setFormData({ ...formData, 'qualif_value_id': sel.value }  ) }
                                        options={reduceQualifValuesList()}
                                        placeholder="Seleccione calificacion"
                                    />
                            }
                            {evalExists?
                                <Input
                                    className="fafafa"
                                    defaultValue={data.calif.comments}
                                    placeholder="Comentarios"
                                    type="textarea"
                                    rows="12"
                                    name="comments"
                                    onChange={handleInputChange}
                                />
                                :
                                <>
                                <Input
                                    className="fafafa"
                                    // value={evalExists?data.calif.q_comments:null}
                                    placeholder="Comentarios"
                                    type="textarea"
                                    rows="12"
                                    name="comments"
                                    onChange={handleInputChange}
                                />
                                </>
                            }
                            </FormGroup>
                         </Form>
                         {saveButtons()}

                </CardBody>
              </Card>
            </div>

        );
        }

export { StudentSubjectEvalCard } ;
